import Hero from "../components/Hero";
import FAQSection from "../components/FAQSection";
import CTABanner from "../components/CTABanner";
import { IMAGES, COPY } from "../lib/_data";

export default function FAQ() {
  const hero = COPY.faq.hero;
  const finalCta = COPY.faq.finalCta;
  return (
    <div data-testid="page-faq">
      <Hero
        image={IMAGES.faqHero}
        eyebrow={hero.eyebrow || "Answers before you ask"}
        title={hero.title || "Frequently asked questions."}
        subtitle={hero.subtitle || "Quick, honest answers to the things homeowners ask us most. Still curious? A real person is always one call away."}
        primaryCta={{ label: hero.primaryCtaLabel || "Book a Consultation", to: hero.primaryCtaTo || "/consultations" }}
        secondaryCta={{ label: hero.secondaryCtaLabel || "Contact Us", to: hero.secondaryCtaTo || "/contact" }}
      />
      <FAQSection />
      <CTABanner
        image={IMAGES.finalCta}
        eyebrow={finalCta.eyebrow || "Ready when you are"}
        title={finalCta.title || "Didn't find your answer?"}
        subtitle={finalCta.subtitle || "Send us a message or call — we'll get back to you within the hour."}
        primary={{ label: finalCta.primaryLabel || "Contact Us", to: finalCta.primaryTo || "/contact" }}
        secondary={{ label: finalCta.secondaryLabel || "Book a Consultation", to: finalCta.secondaryTo || "/consultations" }}
      />
    </div>
  );
}
